<template>
  <div>
    <transition name="menu-transform-hide" mode="out-in">
      <div v-if="menuStatus" class="menu">
        <div class="hidenIcon" @click="hidenMenu" title="隐藏菜单">
          <svg-icon icon-class="hide"></svg-icon>
        </div>
        <div class="outer-container">
          <div class="inner-container">
            <el-menu :default-active="$route.path" mode="vertical" @select="handleSelect" :unique-opened='true'
              background-color="#f5fdfd" text-color="#696969" active-text-color="#86b981">
              <div v-for="(item,index) in modules" :key="'item'+index">
                <el-menu-item v-if="item.childMenus.length===0" :index="item.menuUrl">
                    <div class="menuItem">
                    <div class="menuIcon">
                      <img v-if="activeName === item.menuUrl"
                        :src="require('../../../assets/images/iconActive/'+(item.menuIcon?item.menuIcon:null)+'.png')" alt="">
                      <img v-else :src="require('../../../assets/images/icon/'+(item.menuIcon?item.menuIcon:null)+'.png')" alt="">
                    </div>
                    <span :class="{'activeMenu':activeName === item.menuUrl}">{{item.menuName}}</span>
                  </div>
                </el-menu-item>
                <!--  -->
              </div>
              <div class="mymenu" v-for="(item,index) in modules" :key="'item1s'+index">
                <el-submenu v-if="item.childMenus.length>0" :index="item.menuName">
                  <template slot="title">
                    <div class="menuItem">
                      <div class="menuIcon">
                        <img v-if="activeName === item.menuUrl"
                          :src="require('../../../assets/images/iconActive/'+(item.menuIcon?item.menuIcon:null)+'.png')" alt="">
                        <img v-else :src="require('../../../assets/images/icon/'+(item.menuIcon?item.menuIcon:null)+'.png')"
                          alt="">
                      </div>
                      <span :class="{'activeMenu':activeName === item.menuUrl}">{{item.menuName}}</span>
                    </div>
                  </template>
                  <el-menu-item v-for="(item1,index) in item.childMenus" :key="index" :index="item1.menuUrl">
                    <div class="menuItem">
                      <div class="menuIcon">
                          <svg-icon :class="{'activeMenu':$route.path === item1.menuUrl}"
                          :icon-class="(item1.menuIcon!==undefined && item1.menuIcon!=='')?item1.menuIcon:'manage'" />
                      </div>
                      <span> {{item1.menuName}}</span>
                    </div>
                  </el-menu-item>
                </el-submenu>
              </div>
            </el-menu>
          </div>
        </div>
      </div>
    </transition>
    <div class="hidenMenu" title="显示菜单" v-if="!menuStatus">
      <div class="hidenIcon" @click="hidenMenu">
          <div class="hidenText">显示菜单</div>
        <svg-icon icon-class="show"></svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    menuStatus: Boolean
  },
  computed: {
    ...mapGetters(['modules'])
  },
  data () {
    return {
      // menuStatus: true,
      activeName: '/index'
    }
  },
  watch: {
    $route (route) {
      setTimeout(() => {
        this.activeName = localStorage.getItem('activeName')
      }, 100)
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      localStorage.setItem('menuEnter', true)
      if (this.$route.path !== key) {
        this.$router.push({ path: key })
      }
    },
    hidenMenu () {
      // this.menuStatus = !this.menuStatus
      this.$store.dispatch('menuStatus', !this.menuStatus)
      this.$emit('changeMenuStatus', !this.menuStatus)
    }
  },
  created () {
    if (localStorage.getItem('activeName') !== null) {
      this.activeName = localStorage.getItem('activeName')
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/styles/theme';
/* menu-transform-hide */
.menu-transform-hide-leave-active,
.menu-transform-hide-enter-active {
  transition: all 0.5s;
}
.menu-transform-hide-enter {
  transform: translateX(0px);
}

.menu-transform-hide-leave-to {
  transform: translateX(-150px);
}
/* menu-transform-show */
.menu-transform-show-leave-active,
.menu-transform-show-enter-active {
  transition: all 0.5s;
}
.menu-transform-show-enter {
  transform: translateX(-150px);
}

.menu-transform-show-leave-to {
  transform: translateX(0px);
}
.menu {
  //   height: 2
  position: fixed;
  width: 165px;
  top: 45px;
  //   left: -175px;
  bottom: 0;
  z-index: 10;
  background: #f5fdfd;
  box-shadow: 2px 2px 5px #b7b7b7;
  .hidenIcon {
    text-align: left;
    float: right;
    transform: rotate(180deg);
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    background-color: #eeeff0;
    margin-top: 3px;
    padding: 2px;
    position: absolute;
    right: 0px;
    z-index: 1;
    .svg-icon {
      font-size: 22px;
      color: $themeColor;
    }
  }
  .outer-container {
    font-size: 13px;
    height: 100%;
    position: relative;
    overflow: hidden;
    margin-bottom: 10px;
    .inner-container {
      position: absolute;
      left: 0;
      top: 0;
      right: -17px;
      bottom: 0;
      overflow-x: hidden;
      overflow-y: scroll;
      .menuItem {
        display: flex;
        align-items: center;
        .el-menu-item {
        }
        .activeMenu {
          // color: #39afcd;
          color: $themeColor;
        }
        .menuIcon {
          img {
            width: 14px;
            height: 14px;
            margin-right: 5px;
            padding-bottom: 4px;
          }
        }
      }
    }
  }
}
.hidenMenu {
  position: fixed;
  z-index: 11;
  .hidenIcon {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    background-color: #eeeff0;
    margin-top: 40px;
    // padding: 2px;
    height: 85px;
    display: flex;
    align-items: center;
    border: 1px solid #bcd0da;
    color: $themeColor;
    .hidenText {
      width: 9px;
      // color: #3398cc;
      color: $themeColor;
      font-size: 10px;
    }
    .svg-icon {
      font-size: 18px;
    }
  }
}
.mymenu {
  .el-submenu.is-active .el-submenu__title {
    // color: #39afcd !important;
    color: $themeColor !important;
  }
  .el-submenu .el-menu-item {
    font-size: 13px;
    height: 42px;
    line-height: 42px;
    padding-left: 30px !important;
    .menuIcon {
      margin-right: 5px;
      color: #696969;
      // padding-bottom: 4px;
      //   }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/menu/index.vue